/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Discount_Rule_CreatedInputs */

const vi_toast_discount_rule_created = /** @type {(inputs: Toast_Discount_Rule_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thêm quy tắc chiết khấu`)
};

/**

* @param {Toast_Discount_Rule_CreatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_discount_rule_created = /** @type {((inputs?: Toast_Discount_Rule_CreatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Discount_Rule_CreatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_discount_rule_created(inputs)
});